import { jsx as u } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { twMerge as p } from "tailwind-merge";
const m = d(
  ({ variant: e, color: o, size: n, shape: g, className: s = "", type: b = "button", ...i }, l) => {
    const r = e === "none" ? o : o ?? "primary", t = e === "none" ? n : n ?? "md";
    return /* @__PURE__ */ u(
      "button",
      {
        ref: l,
        "data-givebutter-primitive": "button",
        type: b,
        className: p(
          e === "outline" && "bg-white shadow-sm ring-1 ring-inset disabled:!bg-white",
          e !== "transparent" && e !== "none" && "font-medium",
          e === "transparent" && "bg-transparent text-gray-900",
          e !== "none" && "flex rounded-md",
          e === "none" && "inline-flex h-fit w-fit bg-transparent",
          //
          r === "primary" && e === "solid" && "[&>svg]:text-brand-cobalt-light bg-blue-500 text-white hover:bg-blue-700 active:bg-blue-800 disabled:bg-blue-500",
          r === "primary" && e === "outline" && "text-blue-500 ring-blue-500 hover:bg-blue-50 active:bg-blue-100",
          r === "primary" && e === "transparent" && "text-blue-500",
          r === "primary" && e === "none" && "text-blue-500",
          //
          r === "neutral" && e === "solid" && "bg-gray-100 hover:bg-gray-200 active:bg-gray-300 disabled:bg-gray-100 [&>svg]:text-gray-700",
          r === "neutral" && e === "outline" && "text-gray-900 ring-gray-300 hover:bg-gray-100 active:bg-gray-200",
          r === "neutral" && e === "transparent" && "text-gray-900",
          r === "neutral" && e === "none" && "text-gray-900",
          //
          r === "error" && e === "solid" && "bg-red-600 text-white hover:bg-red-700 active:bg-red-800 disabled:bg-red-600",
          r === "error" && e === "outline" && "text-red-600 ring-red-600 hover:bg-red-50 active:bg-red-100",
          r === "error" && e === "transparent" && "text-red-600",
          r === "error" && e === "none" && "text-red-600",
          //
          r === "warning" && e === "solid" && "bg-orange-700 text-white hover:bg-orange-700 active:bg-orange-800 disabled:bg-orange-700",
          r === "warning" && e === "outline" && "text-orange-700 ring-orange-700 hover:bg-orange-50 active:bg-orange-100",
          r === "warning" && e === "transparent" && "text-orange-700",
          r === "warning" && e === "none" && "text-orange-700",
          //
          r === "success" && e === "solid" && "bg-green-700 text-white hover:bg-green-700 active:bg-green-800 disabled:bg-green-700",
          r === "success" && e === "outline" && "text-green-700 ring-green-700 hover:bg-green-50 active:bg-green-100",
          r === "success" && e === "transparent" && "text-green-700",
          r === "success" && e === "none" && "text-green-700",
          //
          t === "xs" && "gap-1 text-xs",
          t === "xs" && e !== "none" && "h-6 px-2 py-1.5",
          t === "sm" && "gap-1.5 text-sm",
          t === "sm" && e !== "none" && "h-8 px-3 py-2.5",
          t === "md" && "gap-2.5",
          t === "md" && e !== "none" && "h-10 gap-2.5 px-4 py-2.5",
          t === "lg" && "gap-2.5",
          t === "lg" && e !== "none" && "h-12 gap-2.5 px-6 py-2.5",
          //
          g === "square" && "aspect-square",
          g === "square" && t === "xs" && "!p-1.5 [&>svg]:size-3",
          g === "square" && t === "sm" && "!p-2 [&>svg]:size-4",
          g === "square" && t === "md" && "!p-2.5 [&>svg]:size-5",
          g === "square" && t === "lg" && "!p-3 [&>svg]:size-6",
          //
          "whitespace-no-wrap cursor-pointer items-center justify-center text-nowrap border-0 border-solid outline-blue-300 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-60",
          s
        ),
        ...i
      }
    );
  }
);
export {
  m as Button
};
